// PROD-1832 — advertise which client-directive types this build can render, so
// the backend (PROD-1831) can filter out unsupported directives at
// serialization time.
//
// Ratified mechanism (backend, 2026-07-17): a comma-joined
// `X-Directive-Capabilities` request header on the app's API requests. It is
// attached globally in the use-axios request interceptor, so every surface the
// backend reads (chat list/send, signals, bulk-setup, readings, push-token
// upserts) carries it. This replaces the earlier `supported_directives`
// body-field/query-param guess.
//
// Kill switch: with ADVERTISE_DIRECTIVE_CAPABILITIES off the header is omitted
// entirely — note the backend then filters out EVERY directive for this
// client, so turning it off disables all directive-driven flows.

import { BP_CHAT_ENTRY_ENABLED, ADVERTISE_DIRECTIVE_CAPABILITIES } from './backend-flags';

export const DIRECTIVE_CAPABILITIES_HEADER = 'X-Directive-Capabilities';

// A build must only advertise what it will actually render — the BP input
// widget is included only while its render gate (backend-flags) is on.
export const SUPPORTED_DIRECTIVES: string[] = [
  'request_push_permission',
  'choice_buttons',
  'display_bp_reminder_widget',
  'display_predefined_questions',
  ...(BP_CHAT_ENTRY_ENABLED ? ['display_bp_input_widget'] : []),
];

/** Comma-joined `X-Directive-Capabilities` value; empty when advertisement is
 *  off (callers must then omit the header, not send an empty one). */
export function directiveCapabilitiesHeaderValue(): string {
  if (!ADVERTISE_DIRECTIVE_CAPABILITIES) return '';
  return SUPPORTED_DIRECTIVES.join(',');
}
